module.exports = __webpack_public_path__ + "static/media/how_to_ride_2.b18ccd4c.png";